import { render, staticRenderFns } from "./ChooseCreatePaymentWayModal.vue?vue&type=template&id=a8ddee8a&scoped=true"
import script from "./ChooseCreatePaymentWayModal.vue?vue&type=script&lang=js"
export * from "./ChooseCreatePaymentWayModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseCreatePaymentWayModal.vue?vue&type=style&index=0&id=a8ddee8a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ddee8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ddee8a')) {
      api.createRecord('a8ddee8a', component.options)
    } else {
      api.reload('a8ddee8a', component.options)
    }
    module.hot.accept("./ChooseCreatePaymentWayModal.vue?vue&type=template&id=a8ddee8a&scoped=true", function () {
      api.rerender('a8ddee8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/Modal/ChooseCreatePaymentWayModal.vue"
export default component.exports